import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/(private)/dashboard')({
  component: Dashboard,
});

function Dashboard() {
  return <div>Hello "dashboard"!</div>;
}
